import { Button } from '@/components/form/Button';
import SiDownload from '@/icons/SiDownload';
import { cn } from '@/lib/utils';
import { useDownloadItem } from '@/utils/folder';
import { FC, PropsWithChildren, useState } from 'react';
import { toast } from 'sonner';
import { ThumbnailContainer } from './Thumbnail';
import { useSize } from '@/services/explorer/useExplorerProvider';
import { useSelection } from '@/services/selection/useSelectionProvider';
import { FiCheck } from 'react-icons/fi';

export interface ResourceProps {
  name: string;
  id: string;
}

export const Resource: FC<PropsWithChildren<ResourceProps>> = ({ name, id, children }) => {
  const [showButtons, setShowButtons] = useState(false);

  const download = useDownloadItem();

  const [selected] = useSelection(state => [state.selected]);
  const isSelected = selected.has(id);

  return (
    <div
      className="flex flex-col items-center gap-2 relative"
      onMouseEnter={() => {
        setShowButtons(true);
      }}
      onMouseLeave={() => {
        setShowButtons(false);
      }}
    >
      {showButtons && (
        <Button
          onClick={async e => {
            e.stopPropagation();
            await download(id);
            toast(`${name} - downloaded`);
          }}
          className="hover:bg-[#FFF0F5] absolute right-[-5px] top-[-5px] w-[32px] h-[32px] rounded-full bg-white border border-black text-black p-1 mr-3 mt-3 z-50"
        >
          <SiDownload className="text-3xl" />
        </Button>
      )}
            {!isSelected && showButtons && (
        <div className="flex items-center justify-center absolute left-[5px] top-[-5px] w-[32px] h-[32px] rounded-full  border-2 border-white border-opacity-80 text-black p-1 mr-3 mt-3 z-50">
        </div>
      )}
      {isSelected && (
        <div className="flex items-center justify-center absolute left-[5px] top-[-5px] w-[32px] h-[32px] rounded-full bg-primary-600 border-2 border-primary-700 text-black p-1 mr-3 mt-3 z-50">
          <FiCheck className="text-white h-full w-full"/>
        </div>
      )}
      <ThumbnailContainer>{children}</ThumbnailContainer>
      <p className="break-all text-center text-sm leading-4">{name}</p>
    </div>
  );
};

export const ResourceList: FC<PropsWithChildren> = ({ children }) => {
  const [size] = useSize();

  return (
    <div className="my-3 flex flex-col gap-2">
      <div className="mx-5 flex items-center justify-between">
        <label className="text-secondary-std text-sm">Resources</label>
        <div className="flex gap-2"></div>
      </div>
      <div className={cn('grid gap-6 px-6', size.grid)}>{children}</div>
    </div>
  );
};
